import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { SERVICES, whatsappLink } from "@/data/content";

export default function ServicesSection() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="mx-auto max-w-7xl px-4 py-24 sm:px-6"
    >
      <Reveal>
        <div className="mb-12">
          <Eyebrow>Consulting & Education</Eyebrow>
          <SectionTitle className="mt-3">
            Six Pillars of <span className="text-brand">Market Mastery</span>
          </SectionTitle>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.06}>
            <a
              data-testid={`service-card-${s.id}`}
              href={whatsappLink(
                `Hello TEAM X, I'm interested in your "${s.title}" service.`
              )}
              target="_blank"
              rel="noopener noreferrer"
              className="card-trace group flex h-full flex-col rounded-xl border border-line bg-panel p-6"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-4xl font-black text-brand/25 transition-colors duration-300 group-hover:text-brand/60">
                  {s.num}
                </span>
                <ArrowUpRight
                  size={18}
                  className="text-dim transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-brand"
                />
              </div>
              <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.25em] text-brand">
                {s.subtitle}
              </p>
              <h3 className="mt-1.5 font-display text-2xl font-bold uppercase tracking-tight text-ink">
                {s.title}
              </h3>
              <p className="mt-3 flex-1 text-xs leading-relaxed text-mute sm:text-sm">
                {s.description}
              </p>
              <div className="mt-5 flex flex-wrap gap-2 border-t border-line pt-4">
                {s.tags.map((t) => (
                  <span
                    key={t}
                    className="rounded-full border border-line px-2.5 py-1 font-mono text-[9px] uppercase tracking-[0.12em] text-dim"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
